import { useMemo } from 'react';
import { useIsAutorizedUser } from 'store/features/auth/selectors';
import { useHasCarEBoxLocations } from 'entities/cars';
import usePermissions from 'common/hooks/usePermissions';

export const useIsAllowGetCarEBoxLocations = () => {
  const isAutorizedUser = useIsAutorizedUser();
  const hasCarEBoxLocations = useHasCarEBoxLocations();
  const { locatorProAccess } = usePermissions();

  return useMemo(() => (
    isAutorizedUser && locatorProAccess && !hasCarEBoxLocations
  ), [isAutorizedUser, locatorProAccess, hasCarEBoxLocations]);
};
